import React from 'react';
import { Input, Label } from '@rebass/forms';
import useForm from 'hooks/useForm';

export const BrandingNameForm = ({ onCreate, formId }) => {
    const { register, handleSubmit } = useForm();

    const onSubmit = handleSubmit(data => {
        onCreate?.(data);
    });

    return (
        <form id={formId} onSubmit={onSubmit}>
            <Label htmlFor="name">Name</Label>
            <Input {...register('name')} autoComplete="off" required autoFocus />
        </form>
    );
};
